import { render, staticRenderFns } from "./addDepartmentGroup.vue?vue&type=template&id=6d7fdb10&scoped=true&"
import script from "./addDepartmentGroup.vue?vue&type=script&lang=js&"
export * from "./addDepartmentGroup.vue?vue&type=script&lang=js&"
import style0 from "./addDepartmentGroup.vue?vue&type=style&index=0&id=6d7fdb10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7fdb10",
  null
  
)

export default component.exports